// src/pages/Settings.jsx
import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import { useAuth } from "../context/AuthContext";
import Header from "../components/Header";

const Settings = () => {
  const { user, setUser } = useAuth();
  const [address, setAddress] = useState("");
  const [smsNotif, setSmsNotif] = useState(true);

  const handleLogout = () => {
    signOut(auth).then(() => {
      setUser(null);
    });
  };

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <Header user={user} />
      <h1 className="text-2xl font-bold text-green-700 mb-6">⚙️ Settings</h1>

      <div className="bg-white rounded-xl shadow-lg border border-green-100 p-6 mb-6">
        <h2 className="text-lg font-semibold text-green-700 mb-4">📍 Delivery Address</h2>
        <label className="block font-medium text-gray-700 mb-2">Edit Address:</label>
        <textarea
          rows={3}
          className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-green-500 focus:border-transparent"
          placeholder="Update your delivery address..."
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </div>

      <div className="bg-white rounded-xl shadow-lg border border-green-100 p-6 mb-6">
        <h2 className="text-lg font-semibold text-green-700 mb-4">🔔 Notifications</h2>
        <label className="font-medium text-gray-700 mb-2 block">Notification Preferences</label>
        <label className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
          <input
            type="checkbox"
            checked={smsNotif}
            onChange={() => setSmsNotif(!smsNotif)}
            className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
          />
          <span className="text-gray-700">Enable SMS/WhatsApp notifications</span>
        </label>
      </div>

      <div className="bg-white rounded-xl shadow-lg border border-green-100 p-6 mb-6">
        <h2 className="text-lg font-semibold text-green-700 mb-4">👤 Account</h2>
        <div className="space-y-2 text-gray-700">
          <p><strong>Name:</strong> {user.displayName}</p>
          <p><strong>Email:</strong> {user.email}</p>
        </div>
      </div>

      <button
        onClick={handleLogout}
        className="w-full bg-red-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-red-700 transition-all duration-200 shadow-lg"
      >
        🚪 Logout
      </button>
    </div>
  );
};

export default Settings;
